import { Component, Input } from '@angular/core';
import { NavController, PopoverController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'shop-favorite',
  templateUrl: 'shop-favorite.html',
})
export class ShopFavoriteComponent {
  //is_click: boolean = true;
  @Input() shop_data;

  constructor(
    public navCtrl: NavController,
    public apiProv: ApiProvider,
    public comProv: CommonProvider,
    public popoverCtrl: PopoverController,
  ) {
  }

  setFavorite() {
    if (!this.comProv.isLogin()) {
      this.comProv.alertLogin(this.navCtrl);
      return;
    }
    if (this.shop_data['is_click']) {
      return;
    }
    this.shop_data['is_click'] = true;
    /*if (!this.is_click) {
      return;
    }
    this.sleepClick();*/
    
    this.apiProv.dispLoader();
    this.apiProv.post(this.shop_data['_links']['user_favorite_shop_store']['href'])
    .then(data => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      this.popFavorite();
      this.shop_data['is_favorite'] = true;
      this.comProv.setShopFavorite(this.shop_data['id'], true);

      // ホーム表示リセット
      this.comProv.setOptions('is_home_coupon_cache', 0);
      this.comProv.setOptions('is_home_event_cache', 0);
    }).catch(error => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      this.apiProv.statusError(error, this.navCtrl);
    });
  }

  deleteFavorite() {
    if (!this.comProv.isLogin()) {
      this.comProv.alertLogin(this.navCtrl);
      return;
    }
    if (this.shop_data['is_click']) {
      return;
    }
    this.shop_data['is_click'] = true;
    /*if (!this.is_click) {
      return;
    }
    this.sleepClick();*/
    
    this.apiProv.dispLoader();
    this.apiProv.delete(this.shop_data['_links']['user_favorite_shop_destroy']['href'])
    .then(data => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      //this.popFavorite(false);
      this.shop_data['is_favorite'] = false;
      this.comProv.setShopFavorite(this.shop_data['id'], false);

      // ホーム表示リセット
      this.comProv.setOptions('is_home_coupon_cache', 0);
      this.comProv.setOptions('is_home_event_cache', 0);
    }).catch(error => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      this.apiProv.statusError(error, this.navCtrl);
    });
  }

  popFavorite(is_set=true) {
    let popover = this.popoverCtrl.create('ShopSetPage',{is_set:is_set},{cssClass:'custom_popover',enableBackdropDismiss:false});
    popover.present();
  }

  /*sleepClick() {
    this.is_click = false;
    setTimeout(() => {
      this.is_click = true;
    }, 1500)
  }*/
}


// WEBPACK FOOTER //
// ./src/components/shop-favorite/shop-favorite.ts